export const SENSOR_CODES = {
    FUEL: [32, 33, 50, 51, 52, 53, 60, 69]
}